<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <time-line plain :type="simpleTimeline">
        <time-line-item inverted badge-type="danger" badge-icon="done_all">
          <badge slot="header" type="info"
            >Cumple con los requisitos mínimos</badge
          >
          <p slot="content">
            Ser el titular de una cuenta bancaria. No aceptamos cuentas de
            ahorro de trámite simplificado (cuentas virtuales).
          </p>
          <p slot="content">
            Tener un móvil propio
          </p>
          <p slot="content">
            Ser mayor de edad
          </p>
          <p slot="content">
            Ser residente colombiano
          </p>
          <p slot="content">
            Tener email personal
          </p>
        </time-line-item>

        <time-line-item
          :class="{ 'timeline-inverted': responsive }"
          badge-type="primary"
          badge-icon="person_add"
        >
          <badge slot="header" type="info">Regístrate</badge>
          <p slot="content">
            Ingresa la información de tu cuenta y perfil:
          </p>
          <p slot="content">
            Datos personales
          </p>
          <p slot="content">Información financiera</p>
          <p slot="content">Referencias</p>
          <p slot="content">
            Se te enviará un correo de confirmación.
          </p>
        </time-line-item>

        <time-line-item inverted badge-type="danger" badge-icon="attach_money">
          <badge slot="header" type="info"
            >Selecciona la cantidad de dinero y el plazo que se adecuen a tus
            necesidades</badge
          >
          <p slot="content">
            La cantidad mínima solicitada son $120.000 pesos y un plazo de
            financiación mínimo de cinco (5) días calendario y hasta treinta
            (30) días máximo. El cupo máximo inicial para usuarios es de $
            200.000 pesos y de {{ getMaxQuantity() }} pesos para clientes con un
            excelente comportamiento de pago. El propósito es ser puntual en los
            pagos para poder incrementar el cupo de crédito.
          </p>
        </time-line-item>
        <time-line-item
          :class="{ 'timeline-inverted': responsive }"
          badge-type="primary"
          badge-icon="find_in_page"
        >
          <badge slot="header" type="info">Estudio de crédito</badge>
          <p slot="content">
            Los datos ingresados serán verificados, se consultará la información
            en centrales de riesgo y la capacidad de pago. Si es necesario, un
            colaborador de Capital77 se pondrá en contacto contigo. Espera el
            resultado.
          </p>
        </time-line-item>
        <time-line-item inverted badge-type="danger" badge-icon="fingerprint">
          <badge slot="header" type="info">Firma de contrato</badge>
          <p slot="content">
            Confirma el código que se envió al correo electrónico para firmar el
            contrato y asegúrate de tener actualizado el certificado bancario en
            la sección Mis Documentos.
          </p>
        </time-line-item>
        <time-line-item
          :class="{ 'timeline-inverted': responsive }"
          badge-type="primary"
          badge-icon="money_off"
        >
          <badge slot="header" type="info">Desembolso</badge>
          <p slot="content">
            Verificamos los datos de la cuenta y se hace el desembolso. Lo
            confirmamos vía correo electrónico.
          </p>
        </time-line-item>
        <time-line-item inverted badge-type="danger" badge-icon="access_alarm">
          <badge slot="header" type="info">Pago</badge>
          <p slot="content">
            Paga cumplidamente por consignación bancaria (Adjunta soporte de
            pago).
          </p>
        </time-line-item>
      </time-line>
    </div>
  </div>
</template>
<script>
import { TimeLine, TimeLineItem, Badge } from "@/components";
import Constants from "../../constants";
export default {
  components: {
    TimeLine,
    TimeLineItem,
    Badge
  },
  data() {
    return {
      responsive: false
    };
  },
  computed: {
    simpleTimeline() {
      if (this.responsive) {
        return "simple";
      }
      return "";
    }
  },
  methods: {
    getMaxQuantity() {
      let maxQ = localStorage.getItem(Constants.CREDIT_MAX_VALUE);
      return Constants.currencyValue(maxQ ? maxQ : 600000);
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  }
};
</script>
<style></style>
